// ui/src/components/common/Spinner.js
import React from "react";
import { colors } from "../../theme";

function Spinner({ size = 32, thickness = 3 }) {
  const style = {
    width: size,
    height: size,
    borderRadius: 999,
    borderStyle: "solid",
    borderWidth: thickness,
    borderColor: "rgba(148, 163, 184, 0.35)",
    borderTopColor: colors.accent,
    animation: "pomogi-spin 0.7s linear infinite",
    margin: "0 auto",
  };

  return <div style={style} aria-label="Загрузка" role="status" />;
}

export default Spinner;
